export function isSafari() {
	const platformExpression = /Mac|iPhone|iPod|iPad/i;
	const rejectedExpression = /Chrome|Android|CriOS|FxiOS|EdgiOS/i;
	const expectedExpression = /Safari/i;
	const agent = navigator.userAgent;
	if (rejectedExpression.test(agent)) {
		return false;
	}
	return platformExpression.test(agent) && expectedExpression.test(agent);
}
